<template>
  <div class="feed-main">
    <!-- 头部tag -->
    <!-- <div class="feed-main-header">
      <div
        :class="[tagVal == 0 ? 'screenText' : 'garyText']"
        @click="handleChangeTab(0)"
      >
        全部
      </div>
      <div
        :class="[tagVal == 1 ? 'screenText' : 'garyText']"
        @click="handleChangeTab(1)"
      >
        新提交
      </div>
      <div
        :class="[tagVal == 2 ? 'screenText' : 'garyText']"
        @click="handleChangeTab(2)"
      >
        处理中
      </div>
      <div
        :class="[tagVal == 3 ? 'screenText' : 'garyText']"
        @click="handleChangeTab(3)"
      >
        已完成
      </div>
    </div> -->
    <!-- 主体卡片 -->
    <div class="main-count">
      <div
        class="feed-main-coent"
        v-for="item in feedList"
        :key="item.serialNo"
        @click="handleDetail(item)"
      >
        <div class="feed-status">
          <div class="spots">
            <div>{{ item.typeName }}</div>
            <div>{{ item.serialNo }}</div>
          </div>
          <div
            class="status"
            :class="[
              item.status == 0
                ? 'status'
                : item.status == 1
                ? 'gary'
                : 'yellowText',
            ]"
          >
            {{
              item.status == 0
                ? $t("feedBackStatus1")
                : item.status == 1
                ? $t("feedBackStatus2")
                : $t("orderStatus01")
            }}
          </div>
        </div>
        <div class="explain">
          <div class="image-main">
            <div
              class="image"
              v-for="(item1, index) in item.picUrls"
              :key="index"
            >
              <img :src="item1.url" alt="" />
            </div>
          </div>
          <div class="explain-text">{{ item.content }}</div>
        </div>
        <div class="time-address">
          <div class="time">{{ item.createTime }}</div>
          <div class="adress">{{ (language == 'CN' ? item.branchName : item.branchNameEn) || $t("noBRanch") }}</div>
        </div>
      </div>

      <div class="null-img" v-if="feedList.length == 0">
        <img src="../../assets/imgs/robot.png" alt="" />
        <div class="firsr-text">{{ $t("feedCommentsTips") }}</div>
        <div>{{ $t("forwardTips") }}</div>
      </div>
    </div>
    <!-- 反馈按钮 -->
    <div class="backBtn" @click="handleFeedBackFrom">
      {{ $t("feedBackText") }}
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      tagVal: 0,
      stautsVal: 0,
      feedList: [],
      shopId: "",
      customerId: "",
      language: ''
    };
  },
  mounted() {
    this.shopId = localStorage.getItem("shopId");
    let roles = JSON.parse(localStorage.getItem("customerInfoList"));
    this.customerId =
      (roles && roles[0].customerId) || localStorage.getItem("customerId");
    this.getFeedList();
    window.document.title = "意见反馈";
    this.language = localStorage.getItem("language");
  },
  methods: {
    //获取反馈列表
    getFeedList() {
      let data = {
        shopId: this.shopId,
        branchId: "",
        customerId: this.customerId,
        status: "",
        date: "",
        phone: "",
        currentPage: 1,
        pageSize: 1000,
      };
      this.$authAjax.post("/api/wxapp/feedback/list", data).then((res) => {
        let { data } = res.data;
        data.data.map((item) => {
          if (item.picUrls) {
            item.picUrls = JSON.parse(item.picUrls);
          }
          item.createTime = dayjs(item.createTime).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        });
        this.feedList = data.data;
      });
    },
    //改变头部tag
    handleChangeTab(val) {
      this.tagVal = val;
    },
    //提交反馈
    handleFeedBackFrom() {
      this.$router.push({
        path: "/feed/from",
        query: {
          shopId: this.shopId,
          customerId: this.customerId,
        },
      });
    },
    //点击查看详情
    handleDetail(data) {
      this.$router.push({
        name: "FeedDetail",
        params: data,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@function toVw($px) {
  @return ($px / 375) * 100vw;
}
@function toVh($px) {
  @return ($px / 667) * 100vh;
}
.feed-main {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  padding: toVh(16) toVw(16);
  box-sizing: border-box;
  background: #f7f8fa;
  &-header {
    display: flex;
    align-items: center;
    // position: fixed;
    .screenText {
      font-size: toVw(17);
      font-weight: bold;
      color: #52af80;
      line-height: toVh(19);
      margin-right: toVw(24);
    }
    .garyText {
      font-size: toVw(17);
      font-weight: 500;
      color: #b0b0b0;
      line-height: toVh(19);
      margin-right: toVw(24);
    }
  }
  &-coent:last-child {
    margin-bottom: toVh(70);
  }
  &-coent {
    width: toVw(343);
    min-height: toVh(98);
    background: #ffffff;
    box-shadow: 0px 2px 4px 1px rgba(32, 32, 32, 0.1);
    border-radius: 8px 8px 8px 8px;
    margin-top: toVh(12);
    padding: toVh(16) toVw(12) toVh(12) toVw(12);
    box-sizing: border-box;
    .feed-status {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .spots {
        display: flex;
        align-items: center;
        div {
          font-size: toVw(15);
          font-weight: 500;
          color: #202020;
          line-height: toVh(17);
        }
        div:nth-child(2) {
          color: #606060;
          margin-left: toVw(8);
        }
      }
      .status {
        font-size: toVw(15);
        font-weight: 400;
        color: #4bd891;
        line-height: toVh(17);
      }
      .gary {
        color: #c0c0c0;
      }
      .yellowText {
        color: #ffbd09;
      }
    }
    .explain {
      margin-top: toVh(10);
      display: flex;
      align-items: center;
      .image-main {
        flex: 1;
        overflow: auto;
        display: flex;
        align-items: center;
      }
      .image {
        flex-shrink: 0;
        width: toVw(48);
        height: toVh(36);
        border-radius: 4px 4px 4px 4px;
        overflow: hidden;
        margin-right: toVw(2);
      }
      img {
        width: 100%;
        height: 100%;
      }
      &-text {
        width: toVw(106);
        font-size: toVw(14);
        font-weight: 400;
        color: #202020;
        line-height: toVh(16);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: toVw(8);
      }
    }
    .time-address {
      display: flex;
      justify-content: flex-end;
      margin-top: toVh(10);
      .time {
        font-size: toVw(12);
        font-weight: 400;
        color: #909090;
        line-height: toVh(14);
        margin-right: toVw(10);
      }
      .adress {
        font-size: toVw(12);
        font-weight: 400;
        color: #909090;
        line-height: toVh(14);
      }
    }
  }
  .backBtn {
    width: toVw(343);
    height: toVh(52);
    background: linear-gradient(134deg, #4bd891 0%, #05a856 100%);
    border-radius: 27px 27px 27px 27px;
    font-size: toVw(17);
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: toVh(52);
    position: fixed;
    bottom: toVh(24);
  }
}
.null-img {
  margin: toVh(130) auto 0 auto;
  text-align: center;
  font-size: toVw(17);
  font-weight: 400;
  color: #606060;
  line-height: toVh(20);
  .firsr-text {
    margin-top: toVh(30);
  }
}
</style>
